<div class="login-container">
    <nz-spin nzSimple />
    <h2>Automatyczne logowanie..</h2>
    <h3>Jeżeli nie nastąpi automatyczne logowanie, kliknij przycisk poniżej.</h3>
    <button nz-button nzType="default" (click)="login()">Login</button>
</div>
